<template>
	<div class="row">
		<div v-for="coluna in colunas" :key="coluna.situacao" class="col-12 col-md-6 col-xl-3">
			<div class="text-center tituloColuna" :class="coluna.classeTitulo">
				<div class="central">
					<i class="mr-2" :class="coluna.icone"></i> {{ coluna.titulo }} ({{ coluna.itens.length }})
				</div>
			</div>
			<div :id="accordion(coluna)">
				<div v-for="item in coluna.itens" :key="identificador(item)"
					class="cartaoIndividual clickableKanban" :class="coluna.classeCartao">
					<button type="button" class="resumo-consolidado"
						:id="'heading' + identificador(item)"
						data-toggle="collapse"
						:data-target="'#collapse' + identificador(item)"
						aria-expanded="false"
						:aria-controls="'collapse' + identificador(item)">
						<div class="divTitulo">
							<el-tooltip v-if="ehAtividade && item.destaque" content="Atividade em destaque" placement="top">
								<i class="text-warning fas fa-star mr-1"></i>
							</el-tooltip>
							{{ item.titulo.length > 100 ? item.titulo.substring(0, 100) + '... (' + item.codigo + ')' : item.nomeCodigo }}
						</div>
						<div class="datas-consolidado">
							<span>{{ item.dataInicio }} a {{ item.dataFim }}</span>
							<span :class="{ corAtrasada: item.situacao === 'ATRASADA', 'text-success': item.situacao === 'CONCLUIDA' }">
								{{ coluna.descricao }}
							</span>
						</div>
						<div v-if="item.situacao === 'EMANDAMENTO'" class="progress mt-2 progresso-consolidado">
							<div class="progress-bar" role="progressbar" :style="{ width: item.progresso + '%' }"
								:aria-valuenow="item.progresso" aria-valuemin="0" aria-valuemax="100"></div>
						</div>
					</button>
					<div :id="'collapse' + identificador(item)" class="collapse mt-3"
						:aria-labelledby="'heading' + identificador(item)" :data-parent="'#' + accordion(coluna)">
						<div class="acoes-consolidado">
							<div class="responsaveis-consolidado">
								<img v-for="responsavel in responsaveis(item)" :key="responsavel.idusuario"
									:src="responsavel.avatar" :title="responsavel.nome" :alt="responsavel.nome"
									width="27" height="27" class="rounded-circle">
							</div>
							<div class="botoes-consolidado">
								<el-tooltip content="Visualizar Atividade" placement="top">
									<button type="button" class="acao-consolidado icones iconeReagendar" aria-label="Visualizar Atividade"
										@click="$emit('visualizar-atividade', ehAtividade ? item : item.atividade)">
										<i class="far fa-eye"></i>
									</button>
								</el-tooltip>
								<template v-if="item.situacao !== 'CONCLUIDA'">
									<el-tooltip v-for="acao in acoes" :key="acao.nome" :content="acao.nome + ' ' + tipoItem" placement="top">
										<button type="button" class="acao-consolidado icones" :class="acao.classe"
											:aria-label="acao.nome + ' ' + tipoItem"
											@click="$emit(acao.evento + (ehAtividade ? '-atividade' : '-tarefa'), item)">
											<i :class="acao.icone"></i>
										</button>
									</el-tooltip>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { consolidarDemandas } from '../kanban/consolidarDemandas';

export default {
	props: {
		selecao: { type: String, default: 'A' },
		kanban: { type: Object, required: true },
	},
	data() {
		return {
			acoes: [
				{ nome: 'Alterar', evento: 'alterar', classe: 'iconeAlterar', icone: 'fas fa-edit' },
				{ nome: 'Cancelar', evento: 'cancelar', classe: 'iconeCancelar', icone: 'far fa-calendar-times' },
				{ nome: 'Concluir', evento: 'concluir', classe: 'iconeConcluir', icone: 'fas fa-calendar-check' },
			],
		};
	},
	computed: {
		ehAtividade() {
			return this.selecao === 'A';
		},
		tipoItem() {
			return this.ehAtividade ? 'Atividade' : 'Tarefa';
		},
		demanda() {
			return consolidarDemandas(this.kanban);
		},
		colunas() {
			const itens = this.ehAtividade ? this.demanda.listaAtividade : this.demanda.listaTarefa;
			return [
				{ titulo: 'A Fazer', situacao: 'NAOINICIADA', descricao: 'Não Iniciada', classeTitulo: 'colunaFazer', classeCartao: 'cartaoFazer', icone: 'far fa-clock' },
				{ titulo: 'Fazendo', situacao: 'EMANDAMENTO', descricao: 'Em Andamento', classeTitulo: 'colunaFazendo', classeCartao: 'cartaoFazendo', icone: 'fas fa-cog' },
				{ titulo: 'Atrasado', situacao: 'ATRASADA', descricao: 'Atrasada', classeTitulo: 'coluna-atrasados-consolidado', classeCartao: 'cartaoAtrasado', icone: 'fas fa-exclamation-triangle' },
				{ titulo: 'Feito', situacao: 'CONCLUIDA', descricao: 'Concluída', classeTitulo: 'colunaFeito', classeCartao: 'cartaoFeito', icone: 'far fa-check-circle' },
			].map(coluna => ({ ...coluna, itens: itens.filter(item => item.situacao === coluna.situacao) }));
		},
	},
	methods: {
		accordion(coluna) {
			return 'accordionConsolidado' + coluna.situacao;
		},
		identificador(item) {
			return this.ehAtividade ? 'ConsolidadoAtividade' + item.idatividade : 'ConsolidadoTarefa' + item.idtarefa;
		},
		responsaveis(item) {
			if (!this.ehAtividade && item.situacao === 'CONCLUIDA') {
				return item.criador ? [item.criador] : [];
			}
			const atividade = this.ehAtividade ? item : item.atividade;
			return atividade ? atividade.listaResponsavel || [] : [];
		},
	},
};
</script>

<style scoped>
.coluna-atrasados-consolidado {
	color: #b52e2e;
	border-bottom: 1px solid #df4949;
}
.resumo-consolidado {
	display: block;
	width: 100%;
	padding: 0;
	border: 0;
	background: transparent;
	color: inherit;
	font: inherit;
	text-align: left;
	cursor: pointer;
}
.datas-consolidado {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	font-size: 10px;
	margin-top: 15px;
}
.progresso-consolidado {
	height: 3px;
	margin-bottom: 5px;
}
.acoes-consolidado, .botoes-consolidado {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
}
.responsaveis-consolidado img + img {
	margin-left: -10px;
}
.botoes-consolidado {
	margin-left: auto;
}
.acao-consolidado {
	border: 0;
	background: transparent;
	padding: 4px 6px;
}
</style>